// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AajKaSoneKaBhavRouteImport } from './routes/aaj-ka-sone-ka-bhav'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as AdminPortalRouteImport } from './routes/admin-portal'
import { Route as BmiCalculatorForWomenChar123ageChar125YearsOldRouteImport } from './routes/bmi-calculator-for-women-{$age}-years-old'
import { Route as BmiCalculatorForChar123heightChar125RouteImport } from './routes/bmi-calculator-for-{$height}'
import { Route as BmiCalculatorInKgAndFeetForChar123ageChar125YearsOldRouteImport } from './routes/bmi-calculator-in-kg-and-feet-for-{$age}-years-old'
import { Route as CalculatorsRouteImport } from './routes/calculators'
import { Route as ChandiKaRateDelhiRouteImport } from './routes/chandi-ka-rate-delhi'
import { Route as ChandiKaRateJaipurRouteImport } from './routes/chandi-ka-rate-jaipur'
import { Route as ChandiKaRateLucknowRouteImport } from './routes/chandi-ka-rate-lucknow'
import { Route as CheckFescoBillRouteImport } from './routes/check-fesco-bill'
import { Route as CheckGepcoBillRouteImport } from './routes/check-gepco-bill'
import { Route as CheckHescoBillRouteImport } from './routes/check-hesco-bill'
import { Route as CheckIescoBillRouteImport } from './routes/check-iesco-bill'
import { Route as CheckKelectricBillRouteImport } from './routes/check-kelectric-bill'
import { Route as CheckLescoBillRouteImport } from './routes/check-lesco-bill'
import { Route as CheckMepcoBillRouteImport } from './routes/check-mepco-bill'
import { Route as CheckPescoBillRouteImport } from './routes/check-pesco-bill'
import { Route as CheckPtclBillRouteImport } from './routes/check-ptcl-bill'
import { Route as CheckQescoBillRouteImport } from './routes/check-qesco-bill'
import { Route as CheckSepcoBillRouteImport } from './routes/check-sepco-bill'
import { Route as CheckSngplBillRouteImport } from './routes/check-sngpl-bill'
import { Route as CheckSsgcBillRouteImport } from './routes/check-ssgc-bill'
import { Route as ConceptionCalculatorWeekChar123weekChar125RouteImport } from './routes/conception-calculator-week-{$week}'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as EmbedToolsRouteImport } from './routes/embed-tools'
import { Route as GoldInvestmentCalculatorRouteImport } from './routes/gold-investment-calculator'
import { Route as GoldPurityCalculatorRouteImport } from './routes/gold-purity-calculator'
import { Route as GoldRateDelhiRouteImport } from './routes/gold-rate-delhi'
import { Route as GoldRateIndiaRouteImport } from './routes/gold-rate-india'
import { Route as GoldRateKarachiRouteImport } from './routes/gold-rate-karachi'
import { Route as GoldRateLahoreRouteImport } from './routes/gold-rate-lahore'
import { Route as GoldRateMumbaiRouteImport } from './routes/gold-rate-mumbai'
import { Route as GoldRatePakistanRouteImport } from './routes/gold-rate-pakistan'
import { Route as GoldVsSilverPakistanRouteImport } from './routes/gold-vs-silver-pakistan'
import { Route as IndiaRouteImport } from './routes/india'
import { Route as IvfPregnancyCalculatorWeekChar123weekChar125RouteImport } from './routes/ivf-pregnancy-calculator-week-{$week}'
import { Route as JewelryWastageCalculatorRouteImport } from './routes/jewelry-wastage-calculator'
import { Route as LearnRouteImport } from './routes/learn'
import { Route as LiveGoldRateApiRouteImport } from './routes/live-gold-rate-api'
import { Route as LoanHubRouteImport } from './routes/loan-hub'
import { Route as MethodologyRouteImport } from './routes/methodology'
import { Route as PregnancyCalculatorWeekChar123weekChar125RouteImport } from './routes/pregnancy-calculator-week-{$week}'
import { Route as PregnancyCountdownCalculatorChar123weekChar125WeekLeftRouteImport } from './routes/pregnancy-countdown-calculator-{$week}-week-left'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PrizeBondRouteImport } from './routes/prize-bond'
import { Route as PrizeBond100ResultTodayRouteImport } from './routes/prize-bond-100-result-today'
import { Route as PrizeBond1500ResultTodayRouteImport } from './routes/prize-bond-1500-result-today'
import { Route as PrizeBond200ResultTodayRouteImport } from './routes/prize-bond-200-result-today'
import { Route as PrizeBond25000ResultTodayRouteImport } from './routes/prize-bond-25000-result-today'
import { Route as PrizeBond40000ResultTodayRouteImport } from './routes/prize-bond-40000-result-today'
import { Route as PrizeBondList750TodayRouteImport } from './routes/prize-bond-list-750-today'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SilverRateAhmedabadRouteImport } from './routes/silver-rate-ahmedabad'
import { Route as SilverRateBahawalpurRouteImport } from './routes/silver-rate-bahawalpur'
import { Route as SilverRateBangaloreRouteImport } from './routes/silver-rate-bangalore'
import { Route as SilverRateChennaiRouteImport } from './routes/silver-rate-chennai'
import { Route as SilverRateFaisalabadRouteImport } from './routes/silver-rate-faisalabad'
import { Route as SilverRateGujranwalaRouteImport } from './routes/silver-rate-gujranwala'
import { Route as SilverRateHyderabadIndiaRouteImport } from './routes/silver-rate-hyderabad-india'
import { Route as SilverRateHyderabadPakistanRouteImport } from './routes/silver-rate-hyderabad-pakistan'
import { Route as SilverRateIndiaRouteImport } from './routes/silver-rate-india'
import { Route as SilverRateIslamabadRouteImport } from './routes/silver-rate-islamabad'
import { Route as SilverRateKanpurRouteImport } from './routes/silver-rate-kanpur'
import { Route as SilverRateKarachiRouteImport } from './routes/silver-rate-karachi'
import { Route as SilverRateKolkataRouteImport } from './routes/silver-rate-kolkata'
import { Route as SilverRateLahoreRouteImport } from './routes/silver-rate-lahore'
import { Route as SilverRateMultanRouteImport } from './routes/silver-rate-multan'
import { Route as SilverRateMumbaiRouteImport } from './routes/silver-rate-mumbai'
import { Route as SilverRateNagpurRouteImport } from './routes/silver-rate-nagpur'
import { Route as SilverRatePakistanRouteImport } from './routes/silver-rate-pakistan'
import { Route as SilverRatePeshawarRouteImport } from './routes/silver-rate-peshawar'
import { Route as SilverRatePuneRouteImport } from './routes/silver-rate-pune'
import { Route as SilverRateQuettaRouteImport } from './routes/silver-rate-quetta'
import { Route as SilverRateRawalpindiRouteImport } from './routes/silver-rate-rawalpindi'
import { Route as SilverRateSargodhaRouteImport } from './routes/silver-rate-sargodha'
import { Route as SilverRateSialkotRouteImport } from './routes/silver-rate-sialkot'
import { Route as SilverRateSuratRouteImport } from './routes/silver-rate-surat'
import { Route as SiteDirectoryRouteImport } from './routes/site-directory'
import { Route as SoneKaBhav22CaratRouteImport } from './routes/sone-ka-bhav-22-carat'
import { Route as SouthAsianBmiCalculatorForChar123ageChar125YearsOldRouteImport } from './routes/south-asian-bmi-calculator-for-{$age}-years-old'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TodayGoldRateCalculatorIndiaRouteImport } from './routes/today-gold-rate-calculator-india'
import { Route as TodayGoldRateCalculatorPakistanRouteImport } from './routes/today-gold-rate-calculator-pakistan'
import { Route as ToolsRouteImport } from './routes/tools'
import { Route as TwinPregnancyCalculatorWeekChar123weekChar125RouteImport } from './routes/twin-pregnancy-calculator-week-{$week}'
import { Route as UaeRouteImport } from './routes/uae'
import { Route as WidgetRouteImport } from './routes/widget'
import { Route as WidgetsRouteImport } from './routes/widgets'
import { Route as ZakatCalculatorRouteImport } from './routes/zakat-calculator'
import { Route as CountryCityRouteImport } from './routes/$country.$city'
import { Route as AdminBlogRouteImport } from './routes/admin.blog'
import { Route as AdminEarningAppsRouteImport } from './routes/admin.earning-apps'
import { Route as AgeCalculatorIndexRouteImport } from './routes/age-calculator.index'
import { Route as AgeCalculatorBiologicalHealthBmiRouteImport } from './routes/age-calculator.biological-health-bmi'
import { Route as AgeCalculatorChineseLunarAgeRouteImport } from './routes/age-calculator.chinese-lunar-age'
import { Route as AgeCalculatorChronologicalDateDifferenceRouteImport } from './routes/age-calculator.chronological-date-difference'
import { Route as AgeCalculatorFpscPpscJobsRouteImport } from './routes/age-calculator.fpsc-ppsc-jobs'
import { Route as AgeCalculatorGestationalPregnancyRouteImport } from './routes/age-calculator.gestational-pregnancy'
import { Route as AgeCalculatorLifestyleLunarFaceRouteImport } from './routes/age-calculator.lifestyle-lunar-face'
import { Route as AgeCalculatorMilestoneBirthdayRouteImport } from './routes/age-calculator.milestone-birthday'
import { Route as AgeCalculatorMilitaryBhartiRouteImport } from './routes/age-calculator.military-bharti'
import { Route as AgeCalculatorPassportVisaFormRouteImport } from './routes/age-calculator.passport-visa-form'
import { Route as AgeCalculatorPetAgeConverterRouteImport } from './routes/age-calculator.pet-age-converter'
import { Route as AgeCalculatorPetDogCatRouteImport } from './routes/age-calculator.pet-dog-cat'
import { Route as AgeCalculatorRelationshipAgeGapRouteImport } from './routes/age-calculator.relationship-age-gap'
import { Route as AgeCalculatorRetirementCountdownRouteImport } from './routes/age-calculator.retirement-countdown'
import { Route as AgeCalculatorRetirementPensionRouteImport } from './routes/age-calculator.retirement-pension'
import { Route as AgeCalculatorSchoolAdmissionRouteImport } from './routes/age-calculator.school-admission'
import { Route as AgeCalculatorUpscEligibilityRouteImport } from './routes/age-calculator.upsc-eligibility'
import { Route as AppTestingIndexRouteImport } from './routes/app-testing.index'
import { Route as AppTestingGuidelinesRouteImport } from './routes/app-testing.guidelines'
import { Route as AppTestingPortalsRouteImport } from './routes/app-testing.portals'
import { Route as ArGoldRateSaudiArabiaRouteImport } from './routes/ar/gold-rate-saudi-arabia'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BmiCalculatorIndexRouteImport } from './routes/bmi-calculator.index'
import { Route as CheckBillSplatRouteImport } from './routes/check-bill.$'
import { Route as DeveloperGoldRateApiRouteImport } from './routes/developer.gold-rate-api'
import { Route as EarningAppsReviewIndexRouteImport } from './routes/earning-apps-review.index'
import { Route as EarningAppsReviewSlugRouteImport } from './routes/earning-apps-review.$slug'
import { Route as GoTargetRouteImport } from './routes/go.$target'
import { Route as GoldRateSplatRouteImport } from './routes/gold-rate.$'
import { Route as GoldSplatRouteImport } from './routes/gold.$'
import { Route as HelplineIndexRouteImport } from './routes/helpline.index'
import { Route as HelplineSplatRouteImport } from './routes/helpline.$'
import { Route as IndiaIndexRouteImport } from './routes/india.index'
import { Route as IndiaCitiesRouteImport } from './routes/india.cities'
import { Route as IndiaGoldForecastRouteImport } from './routes/india.gold-forecast'
import { Route as IndiaSilverCitiesRouteImport } from './routes/india.silver-cities'
import { Route as LearnSlugRouteImport } from './routes/learn.$slug'
import { Route as LoanCalculatorSplatRouteImport } from './routes/loan-calculator.$'
import { Route as LoansSplatRouteImport } from './routes/loans.$'
import { Route as PakistanIndexRouteImport } from './routes/pakistan.index'
import { Route as Pakistan18kRouteImport } from './routes/pakistan.18k'
import { Route as Pakistan21kRouteImport } from './routes/pakistan.21k'
import { Route as Pakistan22kRouteImport } from './routes/pakistan.22k'
import { Route as Pakistan24kRouteImport } from './routes/pakistan.24k'
import { Route as PakistanCalculatorRouteImport } from './routes/pakistan.calculator'
import { Route as PakistanCitiesRouteImport } from './routes/pakistan.cities'
import { Route as PakistanGoldForecastRouteImport } from './routes/pakistan.gold-forecast'
import { Route as PakistanHistoryRouteImport } from './routes/pakistan.history'
import { Route as PakistanMarketHoursRouteImport } from './routes/pakistan.market-hours'
import { Route as PakistanPer10GramRouteImport } from './routes/pakistan.per-10-gram'
import { Route as PakistanPerGramRouteImport } from './routes/pakistan.per-gram'
import { Route as PakistanPerRattiRouteImport } from './routes/pakistan.per-ratti'
import { Route as PakistanPerTolaRouteImport } from './routes/pakistan.per-tola'
import { Route as PakistanSilverCitiesRouteImport } from './routes/pakistan.silver-cities'
import { Route as PakistanUrduRouteImport } from './routes/pakistan.urdu'
import { Route as PakistanYesterdayRouteImport } from './routes/pakistan.yesterday'
import { Route as PakistanZakatNisabRouteImport } from './routes/pakistan.zakat-nisab'
import { Route as RatesIntentSlugRouteImport } from './routes/rates.$intentSlug'
import { Route as RemoteJobsIndexRouteImport } from './routes/remote-jobs.index'
import { Route as RemoteJobsPortalsRouteImport } from './routes/remote-jobs.portals'
import { Route as RemoteJobsRequirementsRouteImport } from './routes/remote-jobs.requirements'
import { Route as SilverRateSplatRouteImport } from './routes/silver-rate.$'
import { Route as SupportSplatRouteImport } from './routes/support.$'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsToolRouteImport } from './routes/tools.$tool'
import { Route as ToolsAllRouteImport } from './routes/tools.all'
import { Route as ToolsCheckLescoBillOnlineRouteImport } from './routes/tools.check-lesco-bill-online'
import { Route as ToolsFescoDuplicateBillDownloadRouteImport } from './routes/tools.fesco-duplicate-bill-download'
import { Route as ToolsGepcoBillOnlineRouteImport } from './routes/tools.gepco-bill-online'
import { Route as ToolsGoldPurityConverterRouteImport } from './routes/tools.gold-purity-converter'
import { Route as ToolsHelplineFinderRouteImport } from './routes/tools.helpline-finder'
import { Route as ToolsHescoBillOnlineRouteImport } from './routes/tools.hesco-bill-online'
import { Route as ToolsHistoricalRoiCalculatorRouteImport } from './routes/tools.historical-roi-calculator'
import { Route as ToolsIescoBillByReferenceNumberRouteImport } from './routes/tools.iesco-bill-by-reference-number'
import { Route as ToolsIescoOnlineBillCheck14DigitRouteImport } from './routes/tools.iesco-online-bill-check-14-digit'
import { Route as ToolsJewelryMakingEstimatorRouteImport } from './routes/tools.jewelry-making-estimator'
import { Route as ToolsKarachiWaterBillKwsbRouteImport } from './routes/tools.karachi-water-bill-kwsb'
import { Route as ToolsMepcoBillCheckOnlineRouteImport } from './routes/tools.mepco-bill-check-online'
import { Route as ToolsPakistanUtilityBillCheckerRouteImport } from './routes/tools.pakistan-utility-bill-checker'
import { Route as ToolsPescoBillCheckRouteImport } from './routes/tools.pesco-bill-check'
import { Route as ToolsPtclBillCheckOnlineRouteImport } from './routes/tools.ptcl-bill-check-online'
import { Route as ToolsPtclCheckBillOnlineRouteImport } from './routes/tools.ptcl-check-bill-online'
import { Route as ToolsQescoBillCheckRouteImport } from './routes/tools.qesco-bill-check'
import { Route as ToolsSepcoBillOnlineRouteImport } from './routes/tools.sepco-bill-online'
import { Route as ToolsSngplGasBillCheckerRouteImport } from './routes/tools.sngpl-gas-bill-checker'
import { Route as ToolsSngplOnlineBillCheck14DigitRouteImport } from './routes/tools.sngpl-online-bill-check-14-digit'
import { Route as ToolsSsgcGasBillOnlineRouteImport } from './routes/tools.ssgc-gas-bill-online'
import { Route as ToolsTescoBillCheckRouteImport } from './routes/tools.tesco-bill-check'
import { Route as TrCanliGramAltinFiyatlariRouteImport } from './routes/tr.canli-gram-altin-fiyatlari'
import { Route as TrCeyrekCumhuriyetAltinFiyatlariRouteImport } from './routes/tr.ceyrek-cumhuriyet-altin-fiyatlari'
import { Route as TrIlIlAltinFiyatlariKuyumcularRouteImport } from './routes/tr.il-il-altin-fiyatlari-kuyumcular'
import { Route as TrKapalicarsiSerbestPiyasaAltinRouteImport } from './routes/tr.kapalicarsi-serbest-piyasa-altin'
import { Route as TrOnsAltinGrafikYorumlariRouteImport } from './routes/tr.ons-altin-grafik-yorumlari'
import { Route as CountryCityIndexRouteImport } from './routes/$country.$city.index'
import { Route as CityCountryCityRouteImport } from './routes/city.$country.$city'
import { Route as EmbedGoldCountryRouteImport } from './routes/embed.gold.$country'
import { Route as EmbedPageIdRouteImport } from './routes/embed.page.$id'
import { Route as InHiAajKaSonaChandiBhavRouteImport } from './routes/in.hi.aaj-ka-sona-chandi-bhav'
import { Route as InHiGoldRate22k24kRouteImport } from './routes/in.hi.gold-rate-22k-24k'
import { Route as InHiGoldSilverCityRatesRouteImport } from './routes/in.hi.gold-silver-city-rates'
import { Route as InHiGoldWeightPerKiloRouteImport } from './routes/in.hi.gold-weight-per-kilo'
import { Route as PakistanUrduCityRouteImport } from './routes/pakistan.urdu.$city'
import { Route as PakistanVsIndiaRouteImport } from './routes/pakistan.vs.india'
import { Route as RomanHelplineSplatRouteImport } from './routes/roman.helpline.$'
import { Route as SaArGoldBarsBullionsRouteImport } from './routes/sa.ar.gold-bars-bullions'
import { Route as SaArGoldKarat21RouteImport } from './routes/sa.ar.gold-karat-21'
import { Route as SaArGoldPricesTodayRouteImport } from './routes/sa.ar.gold-prices-today'
import { Route as SaArSilverPricesKsaRouteImport } from './routes/sa.ar.silver-prices-ksa'
import { Route as SaArUsedGoldRatesRouteImport } from './routes/sa.ar.used-gold-rates'
import { Route as UrHelplineSplatRouteImport } from './routes/ur.helpline.$'
import { Route as CityCountryCityIndexRouteImport } from './routes/city.$country.$city.index'
import { Route as CityCountryCityKaratRouteImport } from './routes/city.$country.$city.$karat'
import { Route as CountryCityKaratUnitModifierRouteImport } from './routes/$country.$city.$karat.$unit.$modifier'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AajKaSoneKaBhavRoute = AajKaSoneKaBhavRouteImport.update({
            id: '/aaj-ka-sone-ka-bhav',path: '/aaj-ka-sone-ka-bhav',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const AdminPortalRoute = AdminPortalRouteImport.update({
            id: '/admin-portal',path: '/admin-portal',getParentRoute: () => rootRouteImport
          })
const BmiCalculatorForWomenChar123ageChar125YearsOldRoute = BmiCalculatorForWomenChar123ageChar125YearsOldRouteImport.update({
            id: '/bmi-calculator-for-women-{$age}-years-old',path: '/bmi-calculator-for-women-{$age}-years-old',getParentRoute: () => rootRouteImport
          })
const BmiCalculatorForChar123heightChar125Route = BmiCalculatorForChar123heightChar125RouteImport.update({
            id: '/bmi-calculator-for-{$height}',path: '/bmi-calculator-for-{$height}',getParentRoute: () => rootRouteImport
          })
const BmiCalculatorInKgAndFeetForChar123ageChar125YearsOldRoute = BmiCalculatorInKgAndFeetForChar123ageChar125YearsOldRouteImport.update({
            id: '/bmi-calculator-in-kg-and-feet-for-{$age}-years-old',path: '/bmi-calculator-in-kg-and-feet-for-{$age}-years-old',getParentRoute: () => rootRouteImport
          })
const CalculatorsRoute = CalculatorsRouteImport.update({
            id: '/calculators',path: '/calculators',getParentRoute: () => rootRouteImport
          })
const ChandiKaRateDelhiRoute = ChandiKaRateDelhiRouteImport.update({
            id: '/chandi-ka-rate-delhi',path: '/chandi-ka-rate-delhi',getParentRoute: () => rootRouteImport
          })
const ChandiKaRateJaipurRoute = ChandiKaRateJaipurRouteImport.update({
            id: '/chandi-ka-rate-jaipur',path: '/chandi-ka-rate-jaipur',getParentRoute: () => rootRouteImport
          })
const ChandiKaRateLucknowRoute = ChandiKaRateLucknowRouteImport.update({
            id: '/chandi-ka-rate-lucknow',path: '/chandi-ka-rate-lucknow',getParentRoute: () => rootRouteImport
          })
const CheckFescoBillRoute = CheckFescoBillRouteImport.update({
            id: '/check-fesco-bill',path: '/check-fesco-bill',getParentRoute: () => rootRouteImport
          })
const CheckGepcoBillRoute = CheckGepcoBillRouteImport.update({
            id: '/check-gepco-bill',path: '/check-gepco-bill',getParentRoute: () => rootRouteImport
          })
const CheckHescoBillRoute = CheckHescoBillRouteImport.update({
            id: '/check-hesco-bill',path: '/check-hesco-bill',getParentRoute: () => rootRouteImport
          })
const CheckIescoBillRoute = CheckIescoBillRouteImport.update({
            id: '/check-iesco-bill',path: '/check-iesco-bill',getParentRoute: () => rootRouteImport
          })
const CheckKelectricBillRoute = CheckKelectricBillRouteImport.update({
            id: '/check-kelectric-bill',path: '/check-kelectric-bill',getParentRoute: () => rootRouteImport
          })
const CheckLescoBillRoute = CheckLescoBillRouteImport.update({
            id: '/check-lesco-bill',path: '/check-lesco-bill',getParentRoute: () => rootRouteImport
          })
const CheckMepcoBillRoute = CheckMepcoBillRouteImport.update({
            id: '/check-mepco-bill',path: '/check-mepco-bill',getParentRoute: () => rootRouteImport
          })
const CheckPescoBillRoute = CheckPescoBillRouteImport.update({
            id: '/check-pesco-bill',path: '/check-pesco-bill',getParentRoute: () => rootRouteImport
          })
const CheckPtclBillRoute = CheckPtclBillRouteImport.update({
            id: '/check-ptcl-bill',path: '/check-ptcl-bill',getParentRoute: () => rootRouteImport
          })
const CheckQescoBillRoute = CheckQescoBillRouteImport.update({
            id: '/check-qesco-bill',path: '/check-qesco-bill',getParentRoute: () => rootRouteImport
          })
const CheckSepcoBillRoute = CheckSepcoBillRouteImport.update({
            id: '/check-sepco-bill',path: '/check-sepco-bill',getParentRoute: () => rootRouteImport
          })
const CheckSngplBillRoute = CheckSngplBillRouteImport.update({
            id: '/check-sngpl-bill',path: '/check-sngpl-bill',getParentRoute: () => rootRouteImport
          })
const CheckSsgcBillRoute = CheckSsgcBillRouteImport.update({
            id: '/check-ssgc-bill',path: '/check-ssgc-bill',getParentRoute: () => rootRouteImport
          })
const ConceptionCalculatorWeekChar123weekChar125Route = ConceptionCalculatorWeekChar123weekChar125RouteImport.update({
            id: '/conception-calculator-week-{$week}',path: '/conception-calculator-week-{$week}',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const EmbedToolsRoute = EmbedToolsRouteImport.update({
            id: '/embed-tools',path: '/embed-tools',getParentRoute: () => rootRouteImport
          })
const GoldInvestmentCalculatorRoute = GoldInvestmentCalculatorRouteImport.update({
            id: '/gold-investment-calculator',path: '/gold-investment-calculator',getParentRoute: () => rootRouteImport
          })
const GoldPurityCalculatorRoute = GoldPurityCalculatorRouteImport.update({
            id: '/gold-purity-calculator',path: '/gold-purity-calculator',getParentRoute: () => rootRouteImport
          })
const GoldRateDelhiRoute = GoldRateDelhiRouteImport.update({
            id: '/gold-rate-delhi',path: '/gold-rate-delhi',getParentRoute: () => rootRouteImport
          })
const GoldRateIndiaRoute = GoldRateIndiaRouteImport.update({
            id: '/gold-rate-india',path: '/gold-rate-india',getParentRoute: () => rootRouteImport
          })
const GoldRateKarachiRoute = GoldRateKarachiRouteImport.update({
            id: '/gold-rate-karachi',path: '/gold-rate-karachi',getParentRoute: () => rootRouteImport
          })
const GoldRateLahoreRoute = GoldRateLahoreRouteImport.update({
            id: '/gold-rate-lahore',path: '/gold-rate-lahore',getParentRoute: () => rootRouteImport
          })
const GoldRateMumbaiRoute = GoldRateMumbaiRouteImport.update({
            id: '/gold-rate-mumbai',path: '/gold-rate-mumbai',getParentRoute: () => rootRouteImport
          })
const GoldRatePakistanRoute = GoldRatePakistanRouteImport.update({
            id: '/gold-rate-pakistan',path: '/gold-rate-pakistan',getParentRoute: () => rootRouteImport
          })
const GoldVsSilverPakistanRoute = GoldVsSilverPakistanRouteImport.update({
            id: '/gold-vs-silver-pakistan',path: '/gold-vs-silver-pakistan',getParentRoute: () => rootRouteImport
          })
const IndiaRoute = IndiaRouteImport.update({
            id: '/india',path: '/india',getParentRoute: () => rootRouteImport
          })
const IvfPregnancyCalculatorWeekChar123weekChar125Route = IvfPregnancyCalculatorWeekChar123weekChar125RouteImport.update({
            id: '/ivf-pregnancy-calculator-week-{$week}',path: '/ivf-pregnancy-calculator-week-{$week}',getParentRoute: () => rootRouteImport
          })
const JewelryWastageCalculatorRoute = JewelryWastageCalculatorRouteImport.update({
            id: '/jewelry-wastage-calculator',path: '/jewelry-wastage-calculator',getParentRoute: () => rootRouteImport
          })
const LearnRoute = LearnRouteImport.update({
            id: '/learn',path: '/learn',getParentRoute: () => rootRouteImport
          })
const LiveGoldRateApiRoute = LiveGoldRateApiRouteImport.update({
            id: '/live-gold-rate-api',path: '/live-gold-rate-api',getParentRoute: () => rootRouteImport
          })
const LoanHubRoute = LoanHubRouteImport.update({
            id: '/loan-hub',path: '/loan-hub',getParentRoute: () => rootRouteImport
          })
const MethodologyRoute = MethodologyRouteImport.update({
            id: '/methodology',path: '/methodology',getParentRoute: () => rootRouteImport
          })
const PregnancyCalculatorWeekChar123weekChar125Route = PregnancyCalculatorWeekChar123weekChar125RouteImport.update({
            id: '/pregnancy-calculator-week-{$week}',path: '/pregnancy-calculator-week-{$week}',getParentRoute: () => rootRouteImport
          })
const PregnancyCountdownCalculatorChar123weekChar125WeekLeftRoute = PregnancyCountdownCalculatorChar123weekChar125WeekLeftRouteImport.update({
            id: '/pregnancy-countdown-calculator-{$week}-week-left',path: '/pregnancy-countdown-calculator-{$week}-week-left',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PrizeBondRoute = PrizeBondRouteImport.update({
            id: '/prize-bond',path: '/prize-bond',getParentRoute: () => rootRouteImport
          })
const PrizeBond100ResultTodayRoute = PrizeBond100ResultTodayRouteImport.update({
            id: '/prize-bond-100-result-today',path: '/prize-bond-100-result-today',getParentRoute: () => rootRouteImport
          })
const PrizeBond1500ResultTodayRoute = PrizeBond1500ResultTodayRouteImport.update({
            id: '/prize-bond-1500-result-today',path: '/prize-bond-1500-result-today',getParentRoute: () => rootRouteImport
          })
const PrizeBond200ResultTodayRoute = PrizeBond200ResultTodayRouteImport.update({
            id: '/prize-bond-200-result-today',path: '/prize-bond-200-result-today',getParentRoute: () => rootRouteImport
          })
const PrizeBond25000ResultTodayRoute = PrizeBond25000ResultTodayRouteImport.update({
            id: '/prize-bond-25000-result-today',path: '/prize-bond-25000-result-today',getParentRoute: () => rootRouteImport
          })
const PrizeBond40000ResultTodayRoute = PrizeBond40000ResultTodayRouteImport.update({
            id: '/prize-bond-40000-result-today',path: '/prize-bond-40000-result-today',getParentRoute: () => rootRouteImport
          })
const PrizeBondList750TodayRoute = PrizeBondList750TodayRouteImport.update({
            id: '/prize-bond-list-750-today',path: '/prize-bond-list-750-today',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const SilverRateAhmedabadRoute = SilverRateAhmedabadRouteImport.update({
            id: '/silver-rate-ahmedabad',path: '/silver-rate-ahmedabad',getParentRoute: () => rootRouteImport
          })
const SilverRateBahawalpurRoute = SilverRateBahawalpurRouteImport.update({
            id: '/silver-rate-bahawalpur',path: '/silver-rate-bahawalpur',getParentRoute: () => rootRouteImport
          })
const SilverRateBangaloreRoute = SilverRateBangaloreRouteImport.update({
            id: '/silver-rate-bangalore',path: '/silver-rate-bangalore',getParentRoute: () => rootRouteImport
          })
const SilverRateChennaiRoute = SilverRateChennaiRouteImport.update({
            id: '/silver-rate-chennai',path: '/silver-rate-chennai',getParentRoute: () => rootRouteImport
          })
const SilverRateFaisalabadRoute = SilverRateFaisalabadRouteImport.update({
            id: '/silver-rate-faisalabad',path: '/silver-rate-faisalabad',getParentRoute: () => rootRouteImport
          })
const SilverRateGujranwalaRoute = SilverRateGujranwalaRouteImport.update({
            id: '/silver-rate-gujranwala',path: '/silver-rate-gujranwala',getParentRoute: () => rootRouteImport
          })
const SilverRateHyderabadIndiaRoute = SilverRateHyderabadIndiaRouteImport.update({
            id: '/silver-rate-hyderabad-india',path: '/silver-rate-hyderabad-india',getParentRoute: () => rootRouteImport
          })
const SilverRateHyderabadPakistanRoute = SilverRateHyderabadPakistanRouteImport.update({
            id: '/silver-rate-hyderabad-pakistan',path: '/silver-rate-hyderabad-pakistan',getParentRoute: () => rootRouteImport
          })
const SilverRateIndiaRoute = SilverRateIndiaRouteImport.update({
            id: '/silver-rate-india',path: '/silver-rate-india',getParentRoute: () => rootRouteImport
          })
const SilverRateIslamabadRoute = SilverRateIslamabadRouteImport.update({
            id: '/silver-rate-islamabad',path: '/silver-rate-islamabad',getParentRoute: () => rootRouteImport
          })
const SilverRateKanpurRoute = SilverRateKanpurRouteImport.update({
            id: '/silver-rate-kanpur',path: '/silver-rate-kanpur',getParentRoute: () => rootRouteImport
          })
const SilverRateKarachiRoute = SilverRateKarachiRouteImport.update({
            id: '/silver-rate-karachi',path: '/silver-rate-karachi',getParentRoute: () => rootRouteImport
          })
const SilverRateKolkataRoute = SilverRateKolkataRouteImport.update({
            id: '/silver-rate-kolkata',path: '/silver-rate-kolkata',getParentRoute: () => rootRouteImport
          })
const SilverRateLahoreRoute = SilverRateLahoreRouteImport.update({
            id: '/silver-rate-lahore',path: '/silver-rate-lahore',getParentRoute: () => rootRouteImport
          })
const SilverRateMultanRoute = SilverRateMultanRouteImport.update({
            id: '/silver-rate-multan',path: '/silver-rate-multan',getParentRoute: () => rootRouteImport
          })
const SilverRateMumbaiRoute = SilverRateMumbaiRouteImport.update({
            id: '/silver-rate-mumbai',path: '/silver-rate-mumbai',getParentRoute: () => rootRouteImport
          })
const SilverRateNagpurRoute = SilverRateNagpurRouteImport.update({
            id: '/silver-rate-nagpur',path: '/silver-rate-nagpur',getParentRoute: () => rootRouteImport
          })
const SilverRatePakistanRoute = SilverRatePakistanRouteImport.update({
            id: '/silver-rate-pakistan',path: '/silver-rate-pakistan',getParentRoute: () => rootRouteImport
          })
const SilverRatePeshawarRoute = SilverRatePeshawarRouteImport.update({
            id: '/silver-rate-peshawar',path: '/silver-rate-peshawar',getParentRoute: () => rootRouteImport
          })
const SilverRatePuneRoute = SilverRatePuneRouteImport.update({
            id: '/silver-rate-pune',path: '/silver-rate-pune',getParentRoute: () => rootRouteImport
          })
const SilverRateQuettaRoute = SilverRateQuettaRouteImport.update({
            id: '/silver-rate-quetta',path: '/silver-rate-quetta',getParentRoute: () => rootRouteImport
          })
const SilverRateRawalpindiRoute = SilverRateRawalpindiRouteImport.update({
            id: '/silver-rate-rawalpindi',path: '/silver-rate-rawalpindi',getParentRoute: () => rootRouteImport
          })
const SilverRateSargodhaRoute = SilverRateSargodhaRouteImport.update({
            id: '/silver-rate-sargodha',path: '/silver-rate-sargodha',getParentRoute: () => rootRouteImport
          })
const SilverRateSialkotRoute = SilverRateSialkotRouteImport.update({
            id: '/silver-rate-sialkot',path: '/silver-rate-sialkot',getParentRoute: () => rootRouteImport
          })
const SilverRateSuratRoute = SilverRateSuratRouteImport.update({
            id: '/silver-rate-surat',path: '/silver-rate-surat',getParentRoute: () => rootRouteImport
          })
const SiteDirectoryRoute = SiteDirectoryRouteImport.update({
            id: '/site-directory',path: '/site-directory',getParentRoute: () => rootRouteImport
          })
const SoneKaBhav22CaratRoute = SoneKaBhav22CaratRouteImport.update({
            id: '/sone-ka-bhav-22-carat',path: '/sone-ka-bhav-22-carat',getParentRoute: () => rootRouteImport
          })
const SouthAsianBmiCalculatorForChar123ageChar125YearsOldRoute = SouthAsianBmiCalculatorForChar123ageChar125YearsOldRouteImport.update({
            id: '/south-asian-bmi-calculator-for-{$age}-years-old',path: '/south-asian-bmi-calculator-for-{$age}-years-old',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TodayGoldRateCalculatorIndiaRoute = TodayGoldRateCalculatorIndiaRouteImport.update({
            id: '/today-gold-rate-calculator-india',path: '/today-gold-rate-calculator-india',getParentRoute: () => rootRouteImport
          })
const TodayGoldRateCalculatorPakistanRoute = TodayGoldRateCalculatorPakistanRouteImport.update({
            id: '/today-gold-rate-calculator-pakistan',path: '/today-gold-rate-calculator-pakistan',getParentRoute: () => rootRouteImport
          })
const ToolsRoute = ToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => rootRouteImport
          })
const TwinPregnancyCalculatorWeekChar123weekChar125Route = TwinPregnancyCalculatorWeekChar123weekChar125RouteImport.update({
            id: '/twin-pregnancy-calculator-week-{$week}',path: '/twin-pregnancy-calculator-week-{$week}',getParentRoute: () => rootRouteImport
          })
const UaeRoute = UaeRouteImport.update({
            id: '/uae',path: '/uae',getParentRoute: () => rootRouteImport
          })
const WidgetRoute = WidgetRouteImport.update({
            id: '/widget',path: '/widget',getParentRoute: () => rootRouteImport
          })
const WidgetsRoute = WidgetsRouteImport.update({
            id: '/widgets',path: '/widgets',getParentRoute: () => rootRouteImport
          })
const ZakatCalculatorRoute = ZakatCalculatorRouteImport.update({
            id: '/zakat-calculator',path: '/zakat-calculator',getParentRoute: () => rootRouteImport
          })
const CountryCityRoute = CountryCityRouteImport.update({
            id: '/$country/$city',path: '/$country/$city',getParentRoute: () => rootRouteImport
          })
const AdminBlogRoute = AdminBlogRouteImport.update({
            id: '/admin/blog',path: '/admin/blog',getParentRoute: () => rootRouteImport
          })
const AdminEarningAppsRoute = AdminEarningAppsRouteImport.update({
            id: '/admin/earning-apps',path: '/admin/earning-apps',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorIndexRoute = AgeCalculatorIndexRouteImport.update({
            id: '/age-calculator/',path: '/age-calculator/',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorBiologicalHealthBmiRoute = AgeCalculatorBiologicalHealthBmiRouteImport.update({
            id: '/age-calculator/biological-health-bmi',path: '/age-calculator/biological-health-bmi',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorChineseLunarAgeRoute = AgeCalculatorChineseLunarAgeRouteImport.update({
            id: '/age-calculator/chinese-lunar-age',path: '/age-calculator/chinese-lunar-age',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorChronologicalDateDifferenceRoute = AgeCalculatorChronologicalDateDifferenceRouteImport.update({
            id: '/age-calculator/chronological-date-difference',path: '/age-calculator/chronological-date-difference',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorFpscPpscJobsRoute = AgeCalculatorFpscPpscJobsRouteImport.update({
            id: '/age-calculator/fpsc-ppsc-jobs',path: '/age-calculator/fpsc-ppsc-jobs',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorGestationalPregnancyRoute = AgeCalculatorGestationalPregnancyRouteImport.update({
            id: '/age-calculator/gestational-pregnancy',path: '/age-calculator/gestational-pregnancy',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorLifestyleLunarFaceRoute = AgeCalculatorLifestyleLunarFaceRouteImport.update({
            id: '/age-calculator/lifestyle-lunar-face',path: '/age-calculator/lifestyle-lunar-face',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorMilestoneBirthdayRoute = AgeCalculatorMilestoneBirthdayRouteImport.update({
            id: '/age-calculator/milestone-birthday',path: '/age-calculator/milestone-birthday',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorMilitaryBhartiRoute = AgeCalculatorMilitaryBhartiRouteImport.update({
            id: '/age-calculator/military-bharti',path: '/age-calculator/military-bharti',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorPassportVisaFormRoute = AgeCalculatorPassportVisaFormRouteImport.update({
            id: '/age-calculator/passport-visa-form',path: '/age-calculator/passport-visa-form',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorPetAgeConverterRoute = AgeCalculatorPetAgeConverterRouteImport.update({
            id: '/age-calculator/pet-age-converter',path: '/age-calculator/pet-age-converter',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorPetDogCatRoute = AgeCalculatorPetDogCatRouteImport.update({
            id: '/age-calculator/pet-dog-cat',path: '/age-calculator/pet-dog-cat',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorRelationshipAgeGapRoute = AgeCalculatorRelationshipAgeGapRouteImport.update({
            id: '/age-calculator/relationship-age-gap',path: '/age-calculator/relationship-age-gap',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorRetirementCountdownRoute = AgeCalculatorRetirementCountdownRouteImport.update({
            id: '/age-calculator/retirement-countdown',path: '/age-calculator/retirement-countdown',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorRetirementPensionRoute = AgeCalculatorRetirementPensionRouteImport.update({
            id: '/age-calculator/retirement-pension',path: '/age-calculator/retirement-pension',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorSchoolAdmissionRoute = AgeCalculatorSchoolAdmissionRouteImport.update({
            id: '/age-calculator/school-admission',path: '/age-calculator/school-admission',getParentRoute: () => rootRouteImport
          })
const AgeCalculatorUpscEligibilityRoute = AgeCalculatorUpscEligibilityRouteImport.update({
            id: '/age-calculator/upsc-eligibility',path: '/age-calculator/upsc-eligibility',getParentRoute: () => rootRouteImport
          })
const AppTestingIndexRoute = AppTestingIndexRouteImport.update({
            id: '/app-testing/',path: '/app-testing/',getParentRoute: () => rootRouteImport
          })
const AppTestingGuidelinesRoute = AppTestingGuidelinesRouteImport.update({
            id: '/app-testing/guidelines',path: '/app-testing/guidelines',getParentRoute: () => rootRouteImport
          })
const AppTestingPortalsRoute = AppTestingPortalsRouteImport.update({
            id: '/app-testing/portals',path: '/app-testing/portals',getParentRoute: () => rootRouteImport
          })
const ArGoldRateSaudiArabiaRoute = ArGoldRateSaudiArabiaRouteImport.update({
            id: '/ar/gold-rate-saudi-arabia',path: '/ar/gold-rate-saudi-arabia',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const BmiCalculatorIndexRoute = BmiCalculatorIndexRouteImport.update({
            id: '/bmi-calculator/',path: '/bmi-calculator/',getParentRoute: () => rootRouteImport
          })
const CheckBillSplatRoute = CheckBillSplatRouteImport.update({
            id: '/check-bill/$',path: '/check-bill/$',getParentRoute: () => rootRouteImport
          })
const DeveloperGoldRateApiRoute = DeveloperGoldRateApiRouteImport.update({
            id: '/developer/gold-rate-api',path: '/developer/gold-rate-api',getParentRoute: () => rootRouteImport
          })
const EarningAppsReviewIndexRoute = EarningAppsReviewIndexRouteImport.update({
            id: '/earning-apps-review/',path: '/earning-apps-review/',getParentRoute: () => rootRouteImport
          })
const EarningAppsReviewSlugRoute = EarningAppsReviewSlugRouteImport.update({
            id: '/earning-apps-review/$slug',path: '/earning-apps-review/$slug',getParentRoute: () => rootRouteImport
          })
const GoTargetRoute = GoTargetRouteImport.update({
            id: '/go/$target',path: '/go/$target',getParentRoute: () => rootRouteImport
          })
const GoldRateSplatRoute = GoldRateSplatRouteImport.update({
            id: '/gold-rate/$',path: '/gold-rate/$',getParentRoute: () => rootRouteImport
          })
const GoldSplatRoute = GoldSplatRouteImport.update({
            id: '/gold/$',path: '/gold/$',getParentRoute: () => rootRouteImport
          })
const HelplineIndexRoute = HelplineIndexRouteImport.update({
            id: '/helpline/',path: '/helpline/',getParentRoute: () => rootRouteImport
          })
const HelplineSplatRoute = HelplineSplatRouteImport.update({
            id: '/helpline/$',path: '/helpline/$',getParentRoute: () => rootRouteImport
          })
const IndiaIndexRoute = IndiaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => IndiaRoute
          })
const IndiaCitiesRoute = IndiaCitiesRouteImport.update({
            id: '/cities',path: '/cities',getParentRoute: () => IndiaRoute
          })
const IndiaGoldForecastRoute = IndiaGoldForecastRouteImport.update({
            id: '/gold-forecast',path: '/gold-forecast',getParentRoute: () => IndiaRoute
          })
const IndiaSilverCitiesRoute = IndiaSilverCitiesRouteImport.update({
            id: '/silver-cities',path: '/silver-cities',getParentRoute: () => IndiaRoute
          })
const LearnSlugRoute = LearnSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => LearnRoute
          })
const LoanCalculatorSplatRoute = LoanCalculatorSplatRouteImport.update({
            id: '/loan-calculator/$',path: '/loan-calculator/$',getParentRoute: () => rootRouteImport
          })
const LoansSplatRoute = LoansSplatRouteImport.update({
            id: '/loans/$',path: '/loans/$',getParentRoute: () => rootRouteImport
          })
const PakistanIndexRoute = PakistanIndexRouteImport.update({
            id: '/pakistan/',path: '/pakistan/',getParentRoute: () => rootRouteImport
          })
const Pakistan18kRoute = Pakistan18kRouteImport.update({
            id: '/pakistan/18k',path: '/pakistan/18k',getParentRoute: () => rootRouteImport
          })
const Pakistan21kRoute = Pakistan21kRouteImport.update({
            id: '/pakistan/21k',path: '/pakistan/21k',getParentRoute: () => rootRouteImport
          })
const Pakistan22kRoute = Pakistan22kRouteImport.update({
            id: '/pakistan/22k',path: '/pakistan/22k',getParentRoute: () => rootRouteImport
          })
const Pakistan24kRoute = Pakistan24kRouteImport.update({
            id: '/pakistan/24k',path: '/pakistan/24k',getParentRoute: () => rootRouteImport
          })
const PakistanCalculatorRoute = PakistanCalculatorRouteImport.update({
            id: '/pakistan/calculator',path: '/pakistan/calculator',getParentRoute: () => rootRouteImport
          })
const PakistanCitiesRoute = PakistanCitiesRouteImport.update({
            id: '/pakistan/cities',path: '/pakistan/cities',getParentRoute: () => rootRouteImport
          })
const PakistanGoldForecastRoute = PakistanGoldForecastRouteImport.update({
            id: '/pakistan/gold-forecast',path: '/pakistan/gold-forecast',getParentRoute: () => rootRouteImport
          })
const PakistanHistoryRoute = PakistanHistoryRouteImport.update({
            id: '/pakistan/history',path: '/pakistan/history',getParentRoute: () => rootRouteImport
          })
const PakistanMarketHoursRoute = PakistanMarketHoursRouteImport.update({
            id: '/pakistan/market-hours',path: '/pakistan/market-hours',getParentRoute: () => rootRouteImport
          })
const PakistanPer10GramRoute = PakistanPer10GramRouteImport.update({
            id: '/pakistan/per-10-gram',path: '/pakistan/per-10-gram',getParentRoute: () => rootRouteImport
          })
const PakistanPerGramRoute = PakistanPerGramRouteImport.update({
            id: '/pakistan/per-gram',path: '/pakistan/per-gram',getParentRoute: () => rootRouteImport
          })
const PakistanPerRattiRoute = PakistanPerRattiRouteImport.update({
            id: '/pakistan/per-ratti',path: '/pakistan/per-ratti',getParentRoute: () => rootRouteImport
          })
const PakistanPerTolaRoute = PakistanPerTolaRouteImport.update({
            id: '/pakistan/per-tola',path: '/pakistan/per-tola',getParentRoute: () => rootRouteImport
          })
const PakistanSilverCitiesRoute = PakistanSilverCitiesRouteImport.update({
            id: '/pakistan/silver-cities',path: '/pakistan/silver-cities',getParentRoute: () => rootRouteImport
          })
const PakistanUrduRoute = PakistanUrduRouteImport.update({
            id: '/pakistan/urdu',path: '/pakistan/urdu',getParentRoute: () => rootRouteImport
          })
const PakistanYesterdayRoute = PakistanYesterdayRouteImport.update({
            id: '/pakistan/yesterday',path: '/pakistan/yesterday',getParentRoute: () => rootRouteImport
          })
const PakistanZakatNisabRoute = PakistanZakatNisabRouteImport.update({
            id: '/pakistan/zakat-nisab',path: '/pakistan/zakat-nisab',getParentRoute: () => rootRouteImport
          })
const RatesIntentSlugRoute = RatesIntentSlugRouteImport.update({
            id: '/rates/$intentSlug',path: '/rates/$intentSlug',getParentRoute: () => rootRouteImport
          })
const RemoteJobsIndexRoute = RemoteJobsIndexRouteImport.update({
            id: '/remote-jobs/',path: '/remote-jobs/',getParentRoute: () => rootRouteImport
          })
const RemoteJobsPortalsRoute = RemoteJobsPortalsRouteImport.update({
            id: '/remote-jobs/portals',path: '/remote-jobs/portals',getParentRoute: () => rootRouteImport
          })
const RemoteJobsRequirementsRoute = RemoteJobsRequirementsRouteImport.update({
            id: '/remote-jobs/requirements',path: '/remote-jobs/requirements',getParentRoute: () => rootRouteImport
          })
const SilverRateSplatRoute = SilverRateSplatRouteImport.update({
            id: '/silver-rate/$',path: '/silver-rate/$',getParentRoute: () => rootRouteImport
          })
const SupportSplatRoute = SupportSplatRouteImport.update({
            id: '/support/$',path: '/support/$',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ToolsRoute
          })
const ToolsToolRoute = ToolsToolRouteImport.update({
            id: '/$tool',path: '/$tool',getParentRoute: () => ToolsRoute
          })
const ToolsAllRoute = ToolsAllRouteImport.update({
            id: '/all',path: '/all',getParentRoute: () => ToolsRoute
          })
const ToolsCheckLescoBillOnlineRoute = ToolsCheckLescoBillOnlineRouteImport.update({
            id: '/check-lesco-bill-online',path: '/check-lesco-bill-online',getParentRoute: () => ToolsRoute
          })
const ToolsFescoDuplicateBillDownloadRoute = ToolsFescoDuplicateBillDownloadRouteImport.update({
            id: '/fesco-duplicate-bill-download',path: '/fesco-duplicate-bill-download',getParentRoute: () => ToolsRoute
          })
const ToolsGepcoBillOnlineRoute = ToolsGepcoBillOnlineRouteImport.update({
            id: '/gepco-bill-online',path: '/gepco-bill-online',getParentRoute: () => ToolsRoute
          })
const ToolsGoldPurityConverterRoute = ToolsGoldPurityConverterRouteImport.update({
            id: '/gold-purity-converter',path: '/gold-purity-converter',getParentRoute: () => ToolsRoute
          })
const ToolsHelplineFinderRoute = ToolsHelplineFinderRouteImport.update({
            id: '/helpline-finder',path: '/helpline-finder',getParentRoute: () => ToolsRoute
          })
const ToolsHescoBillOnlineRoute = ToolsHescoBillOnlineRouteImport.update({
            id: '/hesco-bill-online',path: '/hesco-bill-online',getParentRoute: () => ToolsRoute
          })
const ToolsHistoricalRoiCalculatorRoute = ToolsHistoricalRoiCalculatorRouteImport.update({
            id: '/historical-roi-calculator',path: '/historical-roi-calculator',getParentRoute: () => ToolsRoute
          })
const ToolsIescoBillByReferenceNumberRoute = ToolsIescoBillByReferenceNumberRouteImport.update({
            id: '/iesco-bill-by-reference-number',path: '/iesco-bill-by-reference-number',getParentRoute: () => ToolsRoute
          })
const ToolsIescoOnlineBillCheck14DigitRoute = ToolsIescoOnlineBillCheck14DigitRouteImport.update({
            id: '/iesco-online-bill-check-14-digit',path: '/iesco-online-bill-check-14-digit',getParentRoute: () => ToolsRoute
          })
const ToolsJewelryMakingEstimatorRoute = ToolsJewelryMakingEstimatorRouteImport.update({
            id: '/jewelry-making-estimator',path: '/jewelry-making-estimator',getParentRoute: () => ToolsRoute
          })
const ToolsKarachiWaterBillKwsbRoute = ToolsKarachiWaterBillKwsbRouteImport.update({
            id: '/karachi-water-bill-kwsb',path: '/karachi-water-bill-kwsb',getParentRoute: () => ToolsRoute
          })
const ToolsMepcoBillCheckOnlineRoute = ToolsMepcoBillCheckOnlineRouteImport.update({
            id: '/mepco-bill-check-online',path: '/mepco-bill-check-online',getParentRoute: () => ToolsRoute
          })
const ToolsPakistanUtilityBillCheckerRoute = ToolsPakistanUtilityBillCheckerRouteImport.update({
            id: '/pakistan-utility-bill-checker',path: '/pakistan-utility-bill-checker',getParentRoute: () => ToolsRoute
          })
const ToolsPescoBillCheckRoute = ToolsPescoBillCheckRouteImport.update({
            id: '/pesco-bill-check',path: '/pesco-bill-check',getParentRoute: () => ToolsRoute
          })
const ToolsPtclBillCheckOnlineRoute = ToolsPtclBillCheckOnlineRouteImport.update({
            id: '/ptcl-bill-check-online',path: '/ptcl-bill-check-online',getParentRoute: () => ToolsRoute
          })
const ToolsPtclCheckBillOnlineRoute = ToolsPtclCheckBillOnlineRouteImport.update({
            id: '/ptcl-check-bill-online',path: '/ptcl-check-bill-online',getParentRoute: () => ToolsRoute
          })
const ToolsQescoBillCheckRoute = ToolsQescoBillCheckRouteImport.update({
            id: '/qesco-bill-check',path: '/qesco-bill-check',getParentRoute: () => ToolsRoute
          })
const ToolsSepcoBillOnlineRoute = ToolsSepcoBillOnlineRouteImport.update({
            id: '/sepco-bill-online',path: '/sepco-bill-online',getParentRoute: () => ToolsRoute
          })
const ToolsSngplGasBillCheckerRoute = ToolsSngplGasBillCheckerRouteImport.update({
            id: '/sngpl-gas-bill-checker',path: '/sngpl-gas-bill-checker',getParentRoute: () => ToolsRoute
          })
const ToolsSngplOnlineBillCheck14DigitRoute = ToolsSngplOnlineBillCheck14DigitRouteImport.update({
            id: '/sngpl-online-bill-check-14-digit',path: '/sngpl-online-bill-check-14-digit',getParentRoute: () => ToolsRoute
          })
const ToolsSsgcGasBillOnlineRoute = ToolsSsgcGasBillOnlineRouteImport.update({
            id: '/ssgc-gas-bill-online',path: '/ssgc-gas-bill-online',getParentRoute: () => ToolsRoute
          })
const ToolsTescoBillCheckRoute = ToolsTescoBillCheckRouteImport.update({
            id: '/tesco-bill-check',path: '/tesco-bill-check',getParentRoute: () => ToolsRoute
          })
const TrCanliGramAltinFiyatlariRoute = TrCanliGramAltinFiyatlariRouteImport.update({
            id: '/tr/canli-gram-altin-fiyatlari',path: '/tr/canli-gram-altin-fiyatlari',getParentRoute: () => rootRouteImport
          })
const TrCeyrekCumhuriyetAltinFiyatlariRoute = TrCeyrekCumhuriyetAltinFiyatlariRouteImport.update({
            id: '/tr/ceyrek-cumhuriyet-altin-fiyatlari',path: '/tr/ceyrek-cumhuriyet-altin-fiyatlari',getParentRoute: () => rootRouteImport
          })
const TrIlIlAltinFiyatlariKuyumcularRoute = TrIlIlAltinFiyatlariKuyumcularRouteImport.update({
            id: '/tr/il-il-altin-fiyatlari-kuyumcular',path: '/tr/il-il-altin-fiyatlari-kuyumcular',getParentRoute: () => rootRouteImport
          })
const TrKapalicarsiSerbestPiyasaAltinRoute = TrKapalicarsiSerbestPiyasaAltinRouteImport.update({
            id: '/tr/kapalicarsi-serbest-piyasa-altin',path: '/tr/kapalicarsi-serbest-piyasa-altin',getParentRoute: () => rootRouteImport
          })
const TrOnsAltinGrafikYorumlariRoute = TrOnsAltinGrafikYorumlariRouteImport.update({
            id: '/tr/ons-altin-grafik-yorumlari',path: '/tr/ons-altin-grafik-yorumlari',getParentRoute: () => rootRouteImport
          })
const CountryCityIndexRoute = CountryCityIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CountryCityRoute
          })
const CityCountryCityRoute = CityCountryCityRouteImport.update({
            id: '/city/$country/$city',path: '/city/$country/$city',getParentRoute: () => rootRouteImport
          })
const EmbedGoldCountryRoute = EmbedGoldCountryRouteImport.update({
            id: '/embed/gold/$country',path: '/embed/gold/$country',getParentRoute: () => rootRouteImport
          })
const EmbedPageIdRoute = EmbedPageIdRouteImport.update({
            id: '/embed/page/$id',path: '/embed/page/$id',getParentRoute: () => rootRouteImport
          })
const InHiAajKaSonaChandiBhavRoute = InHiAajKaSonaChandiBhavRouteImport.update({
            id: '/in/hi/aaj-ka-sona-chandi-bhav',path: '/in/hi/aaj-ka-sona-chandi-bhav',getParentRoute: () => rootRouteImport
          })
const InHiGoldRate22k24kRoute = InHiGoldRate22k24kRouteImport.update({
            id: '/in/hi/gold-rate-22k-24k',path: '/in/hi/gold-rate-22k-24k',getParentRoute: () => rootRouteImport
          })
const InHiGoldSilverCityRatesRoute = InHiGoldSilverCityRatesRouteImport.update({
            id: '/in/hi/gold-silver-city-rates',path: '/in/hi/gold-silver-city-rates',getParentRoute: () => rootRouteImport
          })
const InHiGoldWeightPerKiloRoute = InHiGoldWeightPerKiloRouteImport.update({
            id: '/in/hi/gold-weight-per-kilo',path: '/in/hi/gold-weight-per-kilo',getParentRoute: () => rootRouteImport
          })
const PakistanUrduCityRoute = PakistanUrduCityRouteImport.update({
            id: '/$city',path: '/$city',getParentRoute: () => PakistanUrduRoute
          })
const PakistanVsIndiaRoute = PakistanVsIndiaRouteImport.update({
            id: '/pakistan/vs/india',path: '/pakistan/vs/india',getParentRoute: () => rootRouteImport
          })
const RomanHelplineSplatRoute = RomanHelplineSplatRouteImport.update({
            id: '/roman/helpline/$',path: '/roman/helpline/$',getParentRoute: () => rootRouteImport
          })
const SaArGoldBarsBullionsRoute = SaArGoldBarsBullionsRouteImport.update({
            id: '/sa/ar/gold-bars-bullions',path: '/sa/ar/gold-bars-bullions',getParentRoute: () => rootRouteImport
          })
const SaArGoldKarat21Route = SaArGoldKarat21RouteImport.update({
            id: '/sa/ar/gold-karat-21',path: '/sa/ar/gold-karat-21',getParentRoute: () => rootRouteImport
          })
const SaArGoldPricesTodayRoute = SaArGoldPricesTodayRouteImport.update({
            id: '/sa/ar/gold-prices-today',path: '/sa/ar/gold-prices-today',getParentRoute: () => rootRouteImport
          })
const SaArSilverPricesKsaRoute = SaArSilverPricesKsaRouteImport.update({
            id: '/sa/ar/silver-prices-ksa',path: '/sa/ar/silver-prices-ksa',getParentRoute: () => rootRouteImport
          })
const SaArUsedGoldRatesRoute = SaArUsedGoldRatesRouteImport.update({
            id: '/sa/ar/used-gold-rates',path: '/sa/ar/used-gold-rates',getParentRoute: () => rootRouteImport
          })
const UrHelplineSplatRoute = UrHelplineSplatRouteImport.update({
            id: '/ur/helpline/$',path: '/ur/helpline/$',getParentRoute: () => rootRouteImport
          })
const CityCountryCityIndexRoute = CityCountryCityIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CityCountryCityRoute
          })
const CityCountryCityKaratRoute = CityCountryCityKaratRouteImport.update({
            id: '/$karat',path: '/$karat',getParentRoute: () => CityCountryCityRoute
          })
const CountryCityKaratUnitModifierRoute = CountryCityKaratUnitModifierRouteImport.update({
            id: '/$karat/$unit/$modifier',path: '/$karat/$unit/$modifier',getParentRoute: () => CountryCityRoute
          })





const IndiaRouteChildren = {
  IndiaCitiesRoute: IndiaCitiesRoute,IndiaGoldForecastRoute: IndiaGoldForecastRoute,IndiaSilverCitiesRoute: IndiaSilverCitiesRoute,IndiaIndexRoute: IndiaIndexRoute
}

const IndiaRouteWithChildren = IndiaRoute._addFileChildren(IndiaRouteChildren)




const LearnRouteChildren = {
  LearnSlugRoute: LearnSlugRoute
}

const LearnRouteWithChildren = LearnRoute._addFileChildren(LearnRouteChildren)




const ToolsRouteChildren = {
  ToolsToolRoute: ToolsToolRoute,ToolsAllRoute: ToolsAllRoute,ToolsCheckLescoBillOnlineRoute: ToolsCheckLescoBillOnlineRoute,ToolsFescoDuplicateBillDownloadRoute: ToolsFescoDuplicateBillDownloadRoute,ToolsGepcoBillOnlineRoute: ToolsGepcoBillOnlineRoute,ToolsGoldPurityConverterRoute: ToolsGoldPurityConverterRoute,ToolsHelplineFinderRoute: ToolsHelplineFinderRoute,ToolsHescoBillOnlineRoute: ToolsHescoBillOnlineRoute,ToolsHistoricalRoiCalculatorRoute: ToolsHistoricalRoiCalculatorRoute,ToolsIescoBillByReferenceNumberRoute: ToolsIescoBillByReferenceNumberRoute,ToolsIescoOnlineBillCheck14DigitRoute: ToolsIescoOnlineBillCheck14DigitRoute,ToolsJewelryMakingEstimatorRoute: ToolsJewelryMakingEstimatorRoute,ToolsKarachiWaterBillKwsbRoute: ToolsKarachiWaterBillKwsbRoute,ToolsMepcoBillCheckOnlineRoute: ToolsMepcoBillCheckOnlineRoute,ToolsPakistanUtilityBillCheckerRoute: ToolsPakistanUtilityBillCheckerRoute,ToolsPescoBillCheckRoute: ToolsPescoBillCheckRoute,ToolsPtclBillCheckOnlineRoute: ToolsPtclBillCheckOnlineRoute,ToolsPtclCheckBillOnlineRoute: ToolsPtclCheckBillOnlineRoute,ToolsQescoBillCheckRoute: ToolsQescoBillCheckRoute,ToolsSepcoBillOnlineRoute: ToolsSepcoBillOnlineRoute,ToolsSngplGasBillCheckerRoute: ToolsSngplGasBillCheckerRoute,ToolsSngplOnlineBillCheck14DigitRoute: ToolsSngplOnlineBillCheck14DigitRoute,ToolsSsgcGasBillOnlineRoute: ToolsSsgcGasBillOnlineRoute,ToolsTescoBillCheckRoute: ToolsTescoBillCheckRoute,ToolsIndexRoute: ToolsIndexRoute
}

const ToolsRouteWithChildren = ToolsRoute._addFileChildren(ToolsRouteChildren)




const CountryCityRouteChildren = {
  CountryCityIndexRoute: CountryCityIndexRoute,CountryCityKaratUnitModifierRoute: CountryCityKaratUnitModifierRoute
}

const CountryCityRouteWithChildren = CountryCityRoute._addFileChildren(CountryCityRouteChildren)




const PakistanUrduRouteChildren = {
  PakistanUrduCityRoute: PakistanUrduCityRoute
}

const PakistanUrduRouteWithChildren = PakistanUrduRoute._addFileChildren(PakistanUrduRouteChildren)




const CityCountryCityRouteChildren = {
  CityCountryCityKaratRoute: CityCountryCityKaratRoute,CityCountryCityIndexRoute: CityCountryCityIndexRoute
}

const CityCountryCityRouteWithChildren = CityCountryCityRoute._addFileChildren(CityCountryCityRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AajKaSoneKaBhavRoute: AajKaSoneKaBhavRoute,AboutRoute: AboutRoute,AboutUsRoute: AboutUsRoute,AdminPortalRoute: AdminPortalRoute,BmiCalculatorForWomenChar123ageChar125YearsOldRoute: BmiCalculatorForWomenChar123ageChar125YearsOldRoute,BmiCalculatorForChar123heightChar125Route: BmiCalculatorForChar123heightChar125Route,BmiCalculatorInKgAndFeetForChar123ageChar125YearsOldRoute: BmiCalculatorInKgAndFeetForChar123ageChar125YearsOldRoute,CalculatorsRoute: CalculatorsRoute,ChandiKaRateDelhiRoute: ChandiKaRateDelhiRoute,ChandiKaRateJaipurRoute: ChandiKaRateJaipurRoute,ChandiKaRateLucknowRoute: ChandiKaRateLucknowRoute,CheckFescoBillRoute: CheckFescoBillRoute,CheckGepcoBillRoute: CheckGepcoBillRoute,CheckHescoBillRoute: CheckHescoBillRoute,CheckIescoBillRoute: CheckIescoBillRoute,CheckKelectricBillRoute: CheckKelectricBillRoute,CheckLescoBillRoute: CheckLescoBillRoute,CheckMepcoBillRoute: CheckMepcoBillRoute,CheckPescoBillRoute: CheckPescoBillRoute,CheckPtclBillRoute: CheckPtclBillRoute,CheckQescoBillRoute: CheckQescoBillRoute,CheckSepcoBillRoute: CheckSepcoBillRoute,CheckSngplBillRoute: CheckSngplBillRoute,CheckSsgcBillRoute: CheckSsgcBillRoute,ConceptionCalculatorWeekChar123weekChar125Route: ConceptionCalculatorWeekChar123weekChar125Route,ContactRoute: ContactRoute,DisclaimerRoute: DisclaimerRoute,EmbedToolsRoute: EmbedToolsRoute,GoldInvestmentCalculatorRoute: GoldInvestmentCalculatorRoute,GoldPurityCalculatorRoute: GoldPurityCalculatorRoute,GoldRateDelhiRoute: GoldRateDelhiRoute,GoldRateIndiaRoute: GoldRateIndiaRoute,GoldRateKarachiRoute: GoldRateKarachiRoute,GoldRateLahoreRoute: GoldRateLahoreRoute,GoldRateMumbaiRoute: GoldRateMumbaiRoute,GoldRatePakistanRoute: GoldRatePakistanRoute,GoldVsSilverPakistanRoute: GoldVsSilverPakistanRoute,IndiaRoute: IndiaRouteWithChildren,IvfPregnancyCalculatorWeekChar123weekChar125Route: IvfPregnancyCalculatorWeekChar123weekChar125Route,JewelryWastageCalculatorRoute: JewelryWastageCalculatorRoute,LearnRoute: LearnRouteWithChildren,LiveGoldRateApiRoute: LiveGoldRateApiRoute,LoanHubRoute: LoanHubRoute,MethodologyRoute: MethodologyRoute,PregnancyCalculatorWeekChar123weekChar125Route: PregnancyCalculatorWeekChar123weekChar125Route,PregnancyCountdownCalculatorChar123weekChar125WeekLeftRoute: PregnancyCountdownCalculatorChar123weekChar125WeekLeftRoute,PrivacyRoute: PrivacyRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,PrizeBondRoute: PrizeBondRoute,PrizeBond100ResultTodayRoute: PrizeBond100ResultTodayRoute,PrizeBond1500ResultTodayRoute: PrizeBond1500ResultTodayRoute,PrizeBond200ResultTodayRoute: PrizeBond200ResultTodayRoute,PrizeBond25000ResultTodayRoute: PrizeBond25000ResultTodayRoute,PrizeBond40000ResultTodayRoute: PrizeBond40000ResultTodayRoute,PrizeBondList750TodayRoute: PrizeBondList750TodayRoute,SearchRoute: SearchRoute,SilverRateAhmedabadRoute: SilverRateAhmedabadRoute,SilverRateBahawalpurRoute: SilverRateBahawalpurRoute,SilverRateBangaloreRoute: SilverRateBangaloreRoute,SilverRateChennaiRoute: SilverRateChennaiRoute,SilverRateFaisalabadRoute: SilverRateFaisalabadRoute,SilverRateGujranwalaRoute: SilverRateGujranwalaRoute,SilverRateHyderabadIndiaRoute: SilverRateHyderabadIndiaRoute,SilverRateHyderabadPakistanRoute: SilverRateHyderabadPakistanRoute,SilverRateIndiaRoute: SilverRateIndiaRoute,SilverRateIslamabadRoute: SilverRateIslamabadRoute,SilverRateKanpurRoute: SilverRateKanpurRoute,SilverRateKarachiRoute: SilverRateKarachiRoute,SilverRateKolkataRoute: SilverRateKolkataRoute,SilverRateLahoreRoute: SilverRateLahoreRoute,SilverRateMultanRoute: SilverRateMultanRoute,SilverRateMumbaiRoute: SilverRateMumbaiRoute,SilverRateNagpurRoute: SilverRateNagpurRoute,SilverRatePakistanRoute: SilverRatePakistanRoute,SilverRatePeshawarRoute: SilverRatePeshawarRoute,SilverRatePuneRoute: SilverRatePuneRoute,SilverRateQuettaRoute: SilverRateQuettaRoute,SilverRateRawalpindiRoute: SilverRateRawalpindiRoute,SilverRateSargodhaRoute: SilverRateSargodhaRoute,SilverRateSialkotRoute: SilverRateSialkotRoute,SilverRateSuratRoute: SilverRateSuratRoute,SiteDirectoryRoute: SiteDirectoryRoute,SoneKaBhav22CaratRoute: SoneKaBhav22CaratRoute,SouthAsianBmiCalculatorForChar123ageChar125YearsOldRoute: SouthAsianBmiCalculatorForChar123ageChar125YearsOldRoute,TermsRoute: TermsRoute,TodayGoldRateCalculatorIndiaRoute: TodayGoldRateCalculatorIndiaRoute,TodayGoldRateCalculatorPakistanRoute: TodayGoldRateCalculatorPakistanRoute,ToolsRoute: ToolsRouteWithChildren,TwinPregnancyCalculatorWeekChar123weekChar125Route: TwinPregnancyCalculatorWeekChar123weekChar125Route,UaeRoute: UaeRoute,WidgetRoute: WidgetRoute,WidgetsRoute: WidgetsRoute,ZakatCalculatorRoute: ZakatCalculatorRoute,CountryCityRoute: CountryCityRouteWithChildren,AdminBlogRoute: AdminBlogRoute,AdminEarningAppsRoute: AdminEarningAppsRoute,AgeCalculatorBiologicalHealthBmiRoute: AgeCalculatorBiologicalHealthBmiRoute,AgeCalculatorChineseLunarAgeRoute: AgeCalculatorChineseLunarAgeRoute,AgeCalculatorChronologicalDateDifferenceRoute: AgeCalculatorChronologicalDateDifferenceRoute,AgeCalculatorFpscPpscJobsRoute: AgeCalculatorFpscPpscJobsRoute,AgeCalculatorGestationalPregnancyRoute: AgeCalculatorGestationalPregnancyRoute,AgeCalculatorLifestyleLunarFaceRoute: AgeCalculatorLifestyleLunarFaceRoute,AgeCalculatorMilestoneBirthdayRoute: AgeCalculatorMilestoneBirthdayRoute,AgeCalculatorMilitaryBhartiRoute: AgeCalculatorMilitaryBhartiRoute,AgeCalculatorPassportVisaFormRoute: AgeCalculatorPassportVisaFormRoute,AgeCalculatorPetAgeConverterRoute: AgeCalculatorPetAgeConverterRoute,AgeCalculatorPetDogCatRoute: AgeCalculatorPetDogCatRoute,AgeCalculatorRelationshipAgeGapRoute: AgeCalculatorRelationshipAgeGapRoute,AgeCalculatorRetirementCountdownRoute: AgeCalculatorRetirementCountdownRoute,AgeCalculatorRetirementPensionRoute: AgeCalculatorRetirementPensionRoute,AgeCalculatorSchoolAdmissionRoute: AgeCalculatorSchoolAdmissionRoute,AgeCalculatorUpscEligibilityRoute: AgeCalculatorUpscEligibilityRoute,AppTestingGuidelinesRoute: AppTestingGuidelinesRoute,AppTestingPortalsRoute: AppTestingPortalsRoute,ArGoldRateSaudiArabiaRoute: ArGoldRateSaudiArabiaRoute,BlogSlugRoute: BlogSlugRoute,CheckBillSplatRoute: CheckBillSplatRoute,DeveloperGoldRateApiRoute: DeveloperGoldRateApiRoute,EarningAppsReviewSlugRoute: EarningAppsReviewSlugRoute,GoTargetRoute: GoTargetRoute,GoldRateSplatRoute: GoldRateSplatRoute,GoldSplatRoute: GoldSplatRoute,HelplineSplatRoute: HelplineSplatRoute,LoanCalculatorSplatRoute: LoanCalculatorSplatRoute,LoansSplatRoute: LoansSplatRoute,Pakistan18kRoute: Pakistan18kRoute,Pakistan21kRoute: Pakistan21kRoute,Pakistan22kRoute: Pakistan22kRoute,Pakistan24kRoute: Pakistan24kRoute,PakistanCalculatorRoute: PakistanCalculatorRoute,PakistanCitiesRoute: PakistanCitiesRoute,PakistanGoldForecastRoute: PakistanGoldForecastRoute,PakistanHistoryRoute: PakistanHistoryRoute,PakistanMarketHoursRoute: PakistanMarketHoursRoute,PakistanPer10GramRoute: PakistanPer10GramRoute,PakistanPerGramRoute: PakistanPerGramRoute,PakistanPerRattiRoute: PakistanPerRattiRoute,PakistanPerTolaRoute: PakistanPerTolaRoute,PakistanSilverCitiesRoute: PakistanSilverCitiesRoute,PakistanUrduRoute: PakistanUrduRouteWithChildren,PakistanYesterdayRoute: PakistanYesterdayRoute,PakistanZakatNisabRoute: PakistanZakatNisabRoute,RatesIntentSlugRoute: RatesIntentSlugRoute,RemoteJobsPortalsRoute: RemoteJobsPortalsRoute,RemoteJobsRequirementsRoute: RemoteJobsRequirementsRoute,SilverRateSplatRoute: SilverRateSplatRoute,SupportSplatRoute: SupportSplatRoute,TrCanliGramAltinFiyatlariRoute: TrCanliGramAltinFiyatlariRoute,TrCeyrekCumhuriyetAltinFiyatlariRoute: TrCeyrekCumhuriyetAltinFiyatlariRoute,TrIlIlAltinFiyatlariKuyumcularRoute: TrIlIlAltinFiyatlariKuyumcularRoute,TrKapalicarsiSerbestPiyasaAltinRoute: TrKapalicarsiSerbestPiyasaAltinRoute,TrOnsAltinGrafikYorumlariRoute: TrOnsAltinGrafikYorumlariRoute,AgeCalculatorIndexRoute: AgeCalculatorIndexRoute,AppTestingIndexRoute: AppTestingIndexRoute,BlogIndexRoute: BlogIndexRoute,BmiCalculatorIndexRoute: BmiCalculatorIndexRoute,EarningAppsReviewIndexRoute: EarningAppsReviewIndexRoute,HelplineIndexRoute: HelplineIndexRoute,PakistanIndexRoute: PakistanIndexRoute,RemoteJobsIndexRoute: RemoteJobsIndexRoute,CityCountryCityRoute: CityCountryCityRouteWithChildren,EmbedGoldCountryRoute: EmbedGoldCountryRoute,EmbedPageIdRoute: EmbedPageIdRoute,InHiAajKaSonaChandiBhavRoute: InHiAajKaSonaChandiBhavRoute,InHiGoldRate22k24kRoute: InHiGoldRate22k24kRoute,InHiGoldSilverCityRatesRoute: InHiGoldSilverCityRatesRoute,InHiGoldWeightPerKiloRoute: InHiGoldWeightPerKiloRoute,PakistanVsIndiaRoute: PakistanVsIndiaRoute,RomanHelplineSplatRoute: RomanHelplineSplatRoute,SaArGoldBarsBullionsRoute: SaArGoldBarsBullionsRoute,SaArGoldKarat21Route: SaArGoldKarat21Route,SaArGoldPricesTodayRoute: SaArGoldPricesTodayRoute,SaArSilverPricesKsaRoute: SaArSilverPricesKsaRoute,SaArUsedGoldRatesRoute: SaArUsedGoldRatesRoute,UrHelplineSplatRoute: UrHelplineSplatRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)